import { Record, List } from 'immutable';

/**
 * @name ListModel
 * @desc Represents an abstract list response from the backend.
 * @constant
 */
export const ListModel = new (Record({
    total: 0,
    page: 0,
    perPage: 0,
}))();

/**
 * @class LogEntry
 * @classdesc LogEntry model
 */
export class LogEntry extends Record({
    id: null,
    userId: null,
    action: null,
    resource: null,
    resourceId: null,
    details: null,
    timestamp: null,
}) {}

/**
 * @class LogEntries
 * @classdesc LogEntries model
 */
export class LogEntries extends Record({
    userAuditLog: List(),
    total: 0,
    ...ListModel.toJS(),
}) {
    /**
     * @constructor
     * @param {{entries:[],total:number}} param0
     */
    constructor({ entries, total, ...props } = { entries: [], total: 0 }) {
        super({
            userAuditLog: List(entries.map((entry) => new LogEntry(entry))),
            total,
            ...props,
        });
    }
}

/**
 * @class NotificationsSetting
 * @classdesc NotificationsSetting model
 */
export class NotificationsSetting extends Record({
    sendEventBackupCreated: false,
    sendEventBackupFailed: false,
    sendEventBackupPurged: false,
    sendEventBackupWithErrors: false,
    sendEventScheduleCreated: false,
    sendEventScheduleRemoved: false,
    sendEventSchedulePaused: false,
    sendEventScheduleResumed: false,
    sendEventAgentInstalled: false,
    sendEventAgentRemoved: false,
    sendEventAgentErrored: false,
    sendEventAgentStarted: false,
    sendEventAgentStopped: false,
}) {}
